<!-- -->
<nav
  *ngIf="currentUser"
  class="dct-main-menu">
  <ul class="dct-menu-list">
    <li
      *ngFor="let item of navList; let i = index"
      [ngClass]="{
        'dct-has-subnav': item.childs && item.childs.length > 0,
        'dct-submenu-open': item.expanded
      }">
      <a
        class="dct-main-menu-item"
        [ngClass]="{
          'active': (item.childs && item.childs.length > 0) ? isParentActive(item) : false
        }"
        [routerLink]="item.childs && item.childs.length > 0 ? null : item.link"
        (click)="item.childs && item.childs.length > 0 ? toggleSubmenu(item, $event) : setActive(i)"
        [routerLinkActive]="item.childs && item.childs.length > 0 ? [] : ['active']"
        [attr.data-expanded]="item.expanded"
        >
        <!-- [ngClass]="{ active: activeIndex === i }" -->
        <div
          *ngIf="item.svg"
          class="dct-menu-icon"
          [replaceSvg]="icons[item.svg]"></div>

        <div
          *ngIf="item.img && !item.svg"
          class="dct-menu-icon">
          <img [src]="item.img" [alt]="item.name | translate" />
        </div>

        <span class="dct-nav-text">{{ item.name | translate }}</span>

        <em
          [ngClass]="{
            'd-none': item.childs.length === 0,
            expanded: item.expanded,
          }"
          class="arraw">
          <i class="fa fa-chevron-right"></i>
        </em>
      </a>

      <ul *ngIf="item.childs && item.childs.length > 0 && item.expanded" class="dct-submenu">
        <li *ngFor="let child of item.childs" class="dct-submenu-item">
          <a
            [routerLink]="child.link"
            [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{ exact: true }"
            [attr.title]="child.title | translate"
            (click)="onChildItemClick()">
            <span class="dct-nav-text">{{ child.name | translate }}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</nav>
